import axios from 'axios';
import  qs  from 'qs';
import store from '../store'

/**
 * 调用服务地址
 * @type {string}
 */

let url,Upurl,ImgUrl;

if(process.env.NODE_ENV === 'production') {
  url = window.location.origin + "/alsw-web" + '/pc'; //生产或开发环境下的配置
  Upurl = window.location.origin + "/alsw-web";
  ImgUrl = window.location.origin + '/alsw-pic/';//上传图片的访问地址
}else {
  url = process.env.API_ROOT + '/pc'; //生产或开发环境下的配置
  Upurl = process.env.API_ROOT;
  // ImgUrl = 'http://116.231.99.218:8848/fx-pic/';  //上传图片的访问地址
  ImgUrl = 'http://localhost:8082/alsw-pic/';  //上传图片的访问地址
}

export  {
  url,Upurl,ImgUrl
}

export  const  METHODS= {
  GET: "get",
  POST: "post",
  PUT: "put",
  POST_JSON:"post_json"
}

export  const  http_Req =  (method,action,params)=> {
  return new Promise((resolve, reject) => {
    try {

      //定义请求参数配置
      let config = {
        url: action,
        baseURL: url,
        // 请求方法同上
        method: method.replace('_json', ''),
        transformRequest: [function (data) {
          // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
          switch (method) {
            case METHODS.GET:
            case METHODS.POST:
            case METHODS.PUT:
              return qs.stringify(data);
              break;
            case  METHODS.POST_JSON:
              return JSON.stringify(data);
              break;
          }
        }],

        transformResponse: [function (data) {
          // 这里提前处理返回的数据
          return data;
        }],
        // 请求头信息
        headers: {
          'Content-Type': method === METHODS.POST_JSON ? 'application/json' : 'application/x-www-form-urlencoded',
          'x-auth-token': store.getters.token,
        },
        //设置超时时间
        timeout: 90000,
        //返回数据类型
        responseType: 'json', // default
        // changeOrigin:true,
        withCredentials:true,
      }
     //设置请求数据
      switch (method) {
        case METHODS.GET:
        case METHODS.PUT:
          config.params = params;
          break;
        case METHODS.POST:
        case  METHODS.POST_JSON:
          config.data = params;
          break;
      }

      let reqObj = {
        reqStatus: false, // 成功失败标示  Success 成功  fail 失败
        Data: {status: "FAIL", errorMsg: "请求失败！", result: {}} // 返回参数
      };
      axios(config).then(function (response) {
        //请求成功
        reqObj.Data = response.data;
        //reqObj.reqStatus = response.status === 200 && reqObj.Data.status === "SUCCESS";
        //console.log(typeof (reqObj.Data)==="string");
        reqObj.reqStatus = response.status === 200 && typeof (reqObj.Data)==="string" && JSON.parse(reqObj.Data).status === "SUCCESS"||reqObj.Data.status==="SUCCESS";
        reqObj.Data.constructor === String && (reqObj.Data = JSON.parse(reqObj.Data))
        setTimeout(() => {
          resolve({reqStatus: reqObj.reqStatus, record: reqObj.Data.result, errMsg: reqObj.Data.errorMsg});

        }, 100)
      }).catch(function (response) {
        setTimeout(() => {
          reject(new Error(response instanceof Error ? response.message : "请求失败"))
        }, 100);
      })

    } catch (e) {
      setTimeout(() => {
        reject(e);
      }, 100);
    }

  })
}



export  const  http_ReqFree =  (method,action,params)=> {
  return new Promise((resolve, reject) => {
    try {

      //定义请求参数配置
      let config = {
        url: action,
        baseURL: Upurl,
        // 请求方法同上
        method: method.replace('_json', ''),
        transformRequest: [function (data) {
          // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
          switch (method) {
            case METHODS.GET:
            case METHODS.POST:
            case METHODS.PUT:
              return qs.stringify(data);
              break
            case  METHODS.POST_JSON:
              return JSON.stringify(data);
              break;
          }
        }],

        transformResponse: [function (data) {
          // 这里提前处理返回的数据
          return data;
        }],
        // 请求头信息
        headers: {
          'Content-Type': method === METHODS.POST_JSON ? 'application/json' : 'application/x-www-form-urlencoded',
          'x-auth-token': store.getters.token
        },
        //设置超时时间
        timeout: 60000,
        //返回数据类型
        responseType: 'json', // default
        // changeOrigin:true,
      }
      //设置请求数据
      switch (method) {
        case METHODS.GET:
        case METHODS.PUT:
          config.params = params;
          break;
        case METHODS.POST:
        case  METHODS.POST_JSON:
          config.data = params;
          break;
      }

      let reqObj = {
        reqStatus: false, // 成功失败标示  Success 成功  fail 失败
        Data: {status: "FAIL", errorMsg: "请求失败！", result: {}} // 返回参数
      };

      axios(config).then(function (response) {
        //请求成功
        reqObj.Data = response.data;
        //reqObj.reqStatus = response.status === 200 && reqObj.Data.status === "SUCCESS";
        //console.log(typeof (reqObj.Data)==="string");
        reqObj.reqStatus = response.status === 200 && typeof (reqObj.Data)==="string" && JSON.parse(reqObj.Data).status === "SUCCESS"||reqObj.Data.status==="SUCCESS";

        reqObj.Data.constructor === String && (reqObj.Data = JSON.parse(reqObj.Data))
        setTimeout(() => {
          resolve({reqStatus: reqObj.reqStatus, record: reqObj.Data.result ? reqObj.Data.result: null , errMsg: reqObj.Data.errorMsg ?reqObj.Data.errorMsg :"登录失败，服务器异常" });

        }, 100)
      }).catch(function (response) {
        setTimeout(() => {
          reject(new Error(response instanceof Error ? response.message : "请求失败"))
        }, 150);
      })

    } catch (e) {
      setTimeout(() => {
        reject(e);
      }, 150);
    }

  })
}


/**
 * response拦截器
 */
axios.interceptors.response.use(
  response => {
    if(response){
      if(response.data.status!="SUCCESS" && response.data.errorCode==="S2002"){
        location.href="/";
      }
      else if(response.data.status!="SUCCESS" && response.data.errorCode==="S2006"){
        location.href="/desk";
      }
      return response;
    }

  },
  error => {
    if (error.response) {
      // switch (error.response.status) {
      //   case 401:
      //     // 返回 401 清除token信息并跳转到登录页面
      //     store.commit(types.LOGOUT);
      //     router.replace({
      //       path: 'login',
      //       query: {redirect: router.currentRoute.fullPath}
      //     })
      // }
    }
    return Promise.reject(error.response.data)   // 返回接口返回的错误信息
  });



// WEBPACK FOOTER //
// ./src/api/httpService.js